module.exports = __webpack_public_path__ + "static/media/img_Inscription_kotobuki.a8af06a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_kotobuki.png
// module id = 972
// module chunks = 0